import './index.scss';
import { useContext } from 'react';
import utility from 'src/utils/utility';
import UserContext from 'src/provider/state-manager/userProvider';
import { ViewStudentResult } from 'src/component/ViewResults';

const ViewResults = () => {
    const { user } = useContext(UserContext)

    return (
        <div className='dashboard-view-result'>
            <ViewStudentResult user={user} />
        </div>
    )
}

export default utility.routeData('view-results', 'View Results', <ViewResults />)
